import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef, useCallback } from 'react';
import Navbar from './components/Navbar';
import Footer from '../home/components/Footer';
import SeoHead from '../../components/feature/SeoHead';

interface GalleryData {
  title: string;
  description: string;
  photos: string[];
}

const defaultGalleryData: Record<string, GalleryData> = {
  classical: {
    title: 'Classical World',
    description: 'Selected moments from classical opera and concert performances. Discover more videos and photos on Instagram @weichenvictor.',
    photos: [
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/63bb5315c1f8ff069741ca5233ea26a6.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/80ee417ff0256540675e72188d35ac63.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/7b5fede7a5ab50f38b09a2f40211cda8.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/67ea18d315087b3673f942af8c5aeba6.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/7245094c6e8a9b2d53263cdb96c88656.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/7e5c904e9bc5e9b05f2cd5e01069e14a.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/7b6086f8a19a5c6bafa51dd4c74e6b92.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/4cab1c806dbb259cd5a0ad98da3be0c7.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/69885753bef86f998e351c00db27c863.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/ec5f0be27403a294299123a56378528a.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/77c76dcbfee50f7c9986ed414f2a90bc.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/b12753acb2c80a2a310e638fc415bd73.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/00e08bfc01dc022cfe1c4d6792a75737.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/58c0554a9dc7c3329045693806a62a4c.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/4981ccf658d6c89b5eea13302f524947.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/aa8a74cab255e2680a45052dcfdfaaa8.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/4e6c7a1b03cc362af099601df4c036a3.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/6e575402e799c545d1754a1bd670c5c6.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/c2032691cf9eeb3d41b6dbd43990f49a.jpeg',
    ],
  },
  ventures: {
    title: 'Ventures beyond Classical',
    description: 'Exploring contemporary crossover and diverse musical expressions',
    photos: [],
  },
  metal: {
    title: 'Metal',
    description: '',
    photos: [
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/f70d1e93c788fdabf987c14c4087ebff.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/6757095a267534a026d4125333e83824.jpeg',
    ],
  },
  fujifilm: {
    title: 'Fujifilm Photography',
    description: '',
    photos: [
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/45d3c737781e86060722eb6d59e8b357.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/13e58bf1f1b801f08f12a009e26f6851.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/119ddfed1423d4ac935bead060c0f33a.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/e7209b0a7b0292654e5adb3d65078f42.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/e9214c6c7a238ac1eca5e1d48f0dc695.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/1fe20ce6f614b2c18375ab4a8ab19068.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/215bebf66ce81b61c7fe025c1341bd58.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/e86f2166d7aed5c33cf1ddc61229ee66.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/2e3d6148e96ca007538290ee50328a4b.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/9793646c009dace10ecbc561c769e65f.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/466785b5932ad87734b47060ab44e764.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/de17cbf297250b4458935687d7f98b93.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/a99deb361f407c98277dee35d0142f6e.jpeg',
    ],
  },
  fashion: {
    title: 'Fashion & Dance',
    description: '',
    photos: [
      'https://storage.readdy-site.link/project_files/e7a178d6-0560-413e-a55b-8af9dbae3f7b/a212845c-9a4f-4d1a-bd9f-ad3b754ed96c__20260404000200_104_51.jpg?v=3c81c369f091abfd2fb7114f974658e5',
      'https://storage.readdy-site.link/project_files/e7a178d6-0560-413e-a55b-8af9dbae3f7b/4a8468db-aab0-40ec-ab84-699b8f743445__20260404000224_105_51.jpg?v=56c7d528ea2fc3db3eb78a1a3c9f4105',
      'https://storage.readdy-site.link/project_files/e7a178d6-0560-413e-a55b-8af9dbae3f7b/1901d455-0dee-477b-af60-4f86aea07b5b__20260404000232_106_51.jpg?v=074be76d932dbf10aa83790115816f98',
      'https://storage.readdy-site.link/project_files/e7a178d6-0560-413e-a55b-8af9dbae3f7b/540eb1c0-76a6-4a1e-bd0c-deb22857542b__20260404000240_107_51.jpg?v=7cfec7e3c1ded50b2ad32fb21e2c49f2',
      'https://storage.readdy-site.link/project_files/e7a178d6-0560-413e-a55b-8af9dbae3f7b/2269dcc8-eaac-4ba1-a59d-8d8616f85a21__20260404000247_108_51.jpg?v=e607a01db2a6b49473f83bf37810e3b4',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/a6c57bb53b82932ca69df591a505e0ee.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/a628232741da92f45d74ee7eeeb3a9a5.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/4ca59c2273b6df011a5f70a7374d22bc.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/1ec030d593d2f170f68b7e0aced3fce1.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/56709975d2f399ebd1824c055f151400.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/7c8abe725c6ca5ded8648cae64259d52.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/80d6a2d94a482c1f00b73c01c92aca7d.jpeg',
      'https://static.readdy.ai/image/37826dbbd11b57a8921406d974f7aedc/3de6a0425f8f38d41e75d1ee30c2830b.jpeg',
    ],
  },
};

// ── IndexedDB helpers ──
const DB_NAME = 'gallery_db';
const DB_VERSION = 1;
const STORE_NAME = 'photos';
const THUMB_STORE = 'thumbs';

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) db.createObjectStore(STORE_NAME);
      if (!db.objectStoreNames.contains(THUMB_STORE)) db.createObjectStore(THUMB_STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function idbGet(store: string, key: string): Promise<string | null> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(store, 'readonly');
    const req = tx.objectStore(store).get(key);
    req.onsuccess = () => resolve(req.result ?? null);
    req.onerror = () => reject(req.error);
  });
}

async function idbPut(store: string, key: string, value: string): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(store, 'readwrite');
    tx.objectStore(store).put(value, key);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

// ── 用 Canvas 把图片压缩成缩略图 ──
function compressToThumb(src: string, maxW = 600, quality = 0.8): Promise<string> {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const ratio = img.naturalHeight / img.naturalWidth;
      const w = Math.min(maxW, img.naturalWidth);
      const h = Math.round(w * ratio);
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      if (!ctx) { resolve(src); return; }
      ctx.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL('image/jpeg', quality));
    };
    img.onerror = () => resolve(src);
    img.src = src;
  });
}

// ── 懒加载缩略图组件 ──
interface ThumbProps {
  fullSrc: string;
  alt: string;
  className?: string;
  onClick?: () => void;
  cacheKey: string;
  objectPosition?: string;
}

function ThumbImage({ fullSrc, alt, className, onClick, cacheKey, objectPosition }: ThumbProps) {
  const [thumbSrc, setThumbSrc] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);
  const [inView, setInView] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { rootMargin: '300px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!inView || !fullSrc) return;
    let cancelled = false;
    (async () => {
      if (fullSrc.startsWith('data:')) {
        const t = await compressToThumb(fullSrc);
        if (!cancelled) setThumbSrc(t);
        return;
      }
      try {
        const cached = await idbGet(THUMB_STORE, cacheKey);
        if (cached && !cancelled) { setThumbSrc(cached); return; }
      } catch { /* ignore */ }
      const t = await compressToThumb(fullSrc);
      if (!cancelled) setThumbSrc(t);
      idbPut(THUMB_STORE, cacheKey, t).catch(() => {});
    })();
    return () => { cancelled = true; };
  }, [inView, fullSrc, cacheKey]);

  return (
    <div ref={wrapRef} className="w-full h-full relative">
      {!loaded && (
        <div className="absolute inset-0 bg-champagne-gold/5 animate-pulse" />
      )}
      {thumbSrc && (
        <img
          src={thumbSrc}
          alt={alt}
          className={className}
          style={{ display: loaded ? undefined : 'none', objectPosition: objectPosition ?? undefined }}
          onLoad={() => setLoaded(true)}
          onClick={onClick}
          draggable={false}
        />
      )}
    </div>
  );
}

export default function GallerySubpage() {
  const { category } = useParams<{ category: string }>();
  const navigate = useNavigate();
  const [photos, setPhotos] = useState<string[]>([]);
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const touchStartX = useRef<number>(0);
  const touchCurrentX = useRef<number>(0);
  const [dragOffset, setDragOffset] = useState(0);
  const isDragging = useRef(false);

  const data = category ? defaultGalleryData[category] : null;

  // 只保留有实际图片的条目
  const realPhotos = photos.filter((p) => !!p);

  useEffect(() => {
    if (!data || !category) return;
    const loadAll = async () => {
      const loaded: string[] = [];
      for (let i = 0; i < data.photos.length; i++) {
        const defaultUrl = data.photos[i];
        if (!defaultUrl) continue;
        try {
          const stored = await idbGet(STORE_NAME, `${category}_${i}`);
          const src = stored ?? defaultUrl;
          if (src) loaded.push(src);
        } catch {
          if (defaultUrl) loaded.push(defaultUrl);
        }
      }
      setPhotos(loaded);
    };
    loadAll();
  }, [category]);

  const goNext = useCallback(() => {
    setLightboxIndex((prev) => (prev !== null ? Math.min(prev + 1, realPhotos.length - 1) : prev));
    setDragOffset(0);
  }, [realPhotos.length]);

  const goPrev = useCallback(() => {
    setLightboxIndex((prev) => (prev !== null ? Math.max(prev - 1, 0) : prev));
    setDragOffset(0);
  }, []);

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (lightboxIndex === null) return;
      if (e.key === 'ArrowRight') goNext();
      else if (e.key === 'ArrowLeft') goPrev();
      else if (e.key === 'Escape') setLightboxIndex(null);
    },
    [lightboxIndex, goNext, goPrev]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  const openLightbox = (index: number) => {
    setLightboxIndex(index);
    setDragOffset(0);
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.changedTouches[0].clientX;
    touchCurrentX.current = e.changedTouches[0].clientX;
    isDragging.current = true;
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDragging.current) return;
    touchCurrentX.current = e.changedTouches[0].clientX;
    const diff = touchCurrentX.current - touchStartX.current;
    if (lightboxIndex === 0 && diff > 0) {
      setDragOffset(diff * 0.25);
    } else if (lightboxIndex !== null && lightboxIndex === realPhotos.length - 1 && diff < 0) {
      setDragOffset(diff * 0.25);
    } else {
      setDragOffset(diff);
    }
  };

  const handleTouchEnd = () => {
    isDragging.current = false;
    const diff = touchCurrentX.current - touchStartX.current;
    if (Math.abs(diff) > 60) {
      if (diff < 0) goNext();
      else goPrev();
    } else {
      setDragOffset(0);
    }
  };

  if (!data) {
    return (
      <div className="min-h-screen bg-deep-black flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-cinzel-decorative text-champagne-gold mb-4">Gallery Not Found</h1>
          <button
            onClick={() => navigate('/gallery')}
            className="px-6 py-2 bg-champagne-gold/10 border border-champagne-gold/30 text-champagne-gold font-cinzel hover:bg-champagne-gold/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Back to Gallery
          </button>
        </div>
      </div>
    );
  }

  const seoTitleMap: Record<string, string> = {
    classical: 'Wei Chen – Classical World Gallery | Opera Performance Photos',
    ventures: 'Wei Chen – Ventures beyond Classical | Photo Gallery',
    metal: 'Wei Chen – Metal Gallery | Ventures beyond Classical',
    fujifilm: 'Wei Chen – Fujifilm Photography Gallery',
    fashion: 'Wei Chen – Fashion & Dance Gallery',
  };
  const seoDescMap: Record<string, string> = {
    classical: 'Photos from classical opera and concert performances by New York baritone Wei Chen.',
    ventures: 'Exploring contemporary crossover and diverse musical expressions beyond classical opera.',
    metal: 'Metal music photography from Wei Chen\'s ventures beyond classical music.',
    fujifilm: 'Fujifilm photography collection by baritone Wei Chen.',
    fashion: 'Fashion and dance photography from Wei Chen\'s creative ventures.',
  };
  const seoCanonicalMap: Record<string, string> = {
    classical: '/gallery/classical',
    ventures: '/gallery/ventures',
    metal: '/gallery/ventures/metal',
    fujifilm: '/gallery/ventures/fujifilm',
    fashion: '/gallery/ventures/fashion',
  };

  const subpageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ImageGallery',
    name: seoTitleMap[category ?? ''] ?? `Wei Chen – ${data.title}`,
    description: seoDescMap[category ?? ''] ?? data.description,
    url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}${seoCanonicalMap[category ?? ''] ?? `/gallery/${category}`}`,
    author: {
      '@type': 'Person',
      name: 'Wei Chen',
      jobTitle: 'Baritone',
    },
  };

  const venturesSubCategories = ['metal', 'fujifilm', 'fashion'];
  const backPath = category && venturesSubCategories.includes(category)
    ? '/gallery/ventures'
    : '/gallery';

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0a0a0a' }}>
      <div className="relative z-10">
        <SeoHead
          title={seoTitleMap[category ?? ''] ?? `Wei Chen – ${data.title}`}
          description={seoDescMap[category ?? ''] ?? data.description}
          keywords="Wei Chen, Opera Photography, Baritone, Classical Performance, New York"
          canonical={seoCanonicalMap[category ?? ''] ?? `/gallery/${category}`}
          jsonLd={subpageJsonLd}
        />
        <Navbar />

        {/* Hero Header */}
        <section
          className="pt-32 pb-12 px-6 relative"
          style={
            category === 'classical'
              ? {
                  background: `url('https://public.readdy.ai/ai/img_res/edited_01c6968628282e3959b2269d9deef5d7_e7d13b12.jpg') center/cover no-repeat`,
                }
              : (category === 'metal' || category === 'fujifilm' || category === 'fashion')
              ? {
                  background: `url('https://public.readdy.ai/ai/img_res/edited_ebd3df2806cc3b5732f85b166c2a6d75_19c06641.jpg') center/cover no-repeat`,
                }
              : undefined
          }
        >
          {category === 'classical' && (
            <div className="absolute inset-0 bg-black/70 pointer-events-none" />
          )}
          {(category === 'metal' || category === 'fujifilm' || category === 'fashion') && (
            <>
              <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/35 pointer-events-none"></div>
              <div
                className="absolute inset-0 pointer-events-none"
                style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, transparent 22%, transparent 72%, rgba(0,0,0,0.45) 100%)' }}
              />
            </>
          )}
          <div className="max-w-7xl mx-auto relative z-10">
            <button
              onClick={() => navigate(backPath)}
              className="group flex items-center gap-2 mb-8 text-champagne-gold/70 hover:text-champagne-gold transition-colors duration-300 cursor-pointer whitespace-nowrap"
              style={{ textShadow: '0 1px 6px rgba(0,0,0,0.9)' }}
            >
              <i className="ri-arrow-left-line text-lg transition-transform duration-300 group-hover:-translate-x-1"></i>
              <span className="font-cinzel text-sm tracking-wider">BACK TO GALLERY</span>
            </button>

            <div className="text-center">
              <h1
                className="text-4xl md:text-5xl font-cinzel-decorative font-bold text-champagne-gold mb-4"
                style={{ textShadow: '0 2px 20px rgba(0,0,0,1), 0 4px 32px rgba(0,0,0,0.9)' }}
              >
                {data.title}
              </h1>
              <div className="flex items-center justify-center gap-4 mb-6">
                <div className="h-px w-16 bg-champagne-gold/40"></div>
                <div className="w-5 h-5 flex items-center justify-center text-champagne-gold/60">
                  <i className="ri-image-line text-sm"></i>
                </div>
                <div className="h-px w-16 bg-champagne-gold/40"></div>
              </div>
              {category === 'classical' ? (
                <p
                  className="font-cormorant text-lg text-white max-w-2xl mx-auto mb-4"
                  style={{ textShadow: '0 2px 12px rgba(0,0,0,1), 0 1px 6px rgba(0,0,0,0.9)' }}
                >
                  Selected moments from classical opera and concert performances. Discover more videos and photos on Instagram{' '}
                  <a
                    href="https://www.instagram.com/weichen_victor/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-champagne-gold hover:text-champagne-gold/80 transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    @weichenvictor
                  </a>
                  .
                </p>
              ) : (
                <p
                  className="font-cormorant text-lg text-white max-w-2xl mx-auto mb-4"
                  style={{ textShadow: '0 2px 12px rgba(0,0,0,1), 0 1px 6px rgba(0,0,0,0.9)' }}
                >
                  {data.description}
                </p>
              )}
              {category === 'fujifilm' && (
                <p
                  className="font-cormorant text-base text-white/90 max-w-3xl mx-auto"
                  style={{ textShadow: '0 2px 12px rgba(0,0,0,1), 0 1px 6px rgba(0,0,0,0.9)' }}
                >
                  For more uncompressed, full-resolution photography or to book a street or portrait session, please follow my photography page on Instagram{' '}
                  <a
                    href="https://www.instagram.com/weichen.photographer/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-champagne-gold hover:text-champagne-gold/80 transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    @weichen.photographer
                  </a>
                  .
                </p>
              )}
              {category === 'fashion' && (
                <p
                  className="font-cormorant text-base text-white/90 max-w-3xl mx-auto"
                  style={{ textShadow: '0 2px 12px rgba(0,0,0,1), 0 1px 6px rgba(0,0,0,0.9)' }}
                >
                  For more uncompressed, full-resolution photography or to book a street or portrait session, please follow my photography page on Instagram{' '}
                  <a
                    href="https://www.instagram.com/weichen.photographer/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-champagne-gold hover:text-champagne-gold/80 transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  >
                    @weichen.photographer
                  </a>
                  .
                </p>
              )}
            </div>
          </div>
        </section>

        {/* Spacer */}
        <div className="h-10 bg-[#111111]" />

        {/* Photo Grid — 只渲染有图片的格子 */}
        <section className="pb-24 px-4 md:px-6 bg-[#111111]">
          <div className="max-w-7xl mx-auto">
            {realPhotos.length > 0 ? (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
                {realPhotos.map((photo, index) => {
                  const objectPosition =
                    category === 'classical' && index === 7 ? 'left' : undefined;
                  return (
                    <div
                      key={index}
                      className="group relative aspect-[3/4] overflow-hidden cursor-pointer"
                      onClick={() => openLightbox(index)}
                    >
                      <ThumbImage
                        fullSrc={photo}
                        cacheKey={`v4_${category}_thumb_${index}`}
                        alt={`${data.title} - Photo ${index + 1}`}
                        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                        objectPosition={objectPosition}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                      <div
                        className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                        style={{ boxShadow: 'inset 0 0 0 2px rgba(201,168,76,0.5)' }}
                      />
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-32 text-champagne-gold/30">
                <div className="w-16 h-16 flex items-center justify-center mb-4">
                  <i className="ri-image-line text-5xl"></i>
                </div>
                <p className="font-cinzel text-sm tracking-widest">COMING SOON</p>
              </div>
            )}
          </div>
        </section>

        {/* Lightbox */}
        {lightboxIndex !== null && realPhotos.length > 0 && (
          <div
            className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center overflow-hidden"
            onClick={() => setLightboxIndex(null)}
          >
            <button
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center text-champagne-gold hover:text-white transition-colors duration-300 cursor-pointer whitespace-nowrap z-20"
              onClick={() => setLightboxIndex(null)}
            >
              <i className="ri-close-line text-3xl"></i>
            </button>

            <div className="absolute inset-0 flex items-center"
              style={{ pointerEvents: 'none' }}
            >
              <div
                className="flex h-full items-center"
                style={{
                  width: `${realPhotos.length * 100}vw`,
                  transform: `translateX(calc(-${lightboxIndex * 100}vw + ${dragOffset}px))`,
                  transition: isDragging.current ? 'none' : 'transform 0.38s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                  willChange: 'transform',
                }}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
              >
                {realPhotos.map((src, i) => {
                  const shouldRender = Math.abs(i - lightboxIndex) <= 1;
                  return (
                    <div
                      key={i}
                      className="flex items-center justify-center flex-shrink-0"
                      style={{ width: '100vw', height: '100vh', pointerEvents: 'auto' }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {shouldRender && (
                        <LightboxImage src={src} alt={`Photo ${i + 1}`} />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {lightboxIndex > 0 && (
              <button
                className="absolute left-3 md:left-6 w-11 h-11 flex items-center justify-center rounded-full bg-black/50 backdrop-blur-sm border border-champagne-gold/30 text-champagne-gold hover:bg-champagne-gold/20 transition-all duration-300 cursor-pointer whitespace-nowrap z-20"
                onClick={(e) => { e.stopPropagation(); goPrev(); }}
              >
                <i className="ri-arrow-left-s-line text-2xl"></i>
              </button>
            )}

            {lightboxIndex < realPhotos.length - 1 && (
              <button
                className="absolute right-3 md:right-6 w-11 h-11 flex items-center justify-center rounded-full bg-black/50 backdrop-blur-sm border border-champagne-gold/30 text-champagne-gold hover:bg-champagne-gold/20 transition-all duration-300 cursor-pointer whitespace-nowrap z-20"
                onClick={(e) => { e.stopPropagation(); goNext(); }}
              >
                <i className="ri-arrow-right-s-line text-2xl"></i>
              </button>
            )}

            <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-1.5 z-20">
              {realPhotos.map((_, i) => (
                <button
                  key={i}
                  className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
                    i === lightboxIndex ? 'bg-champagne-gold w-4' : 'bg-champagne-gold/30 w-1.5'
                  }`}
                  onClick={(e) => { e.stopPropagation(); setLightboxIndex(i); setDragOffset(0); }}
                />
              ))}
            </div>
          </div>
        )}

        <Footer />
      </div>
    </div>
  );
}

// ── Lightbox 原图加载组件 ──
function LightboxImage({ src, alt }: { src: string; alt: string }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="relative flex items-center justify-center w-full h-full">
      {!loaded && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-10 h-10 border-2 border-champagne-gold/30 border-t-champagne-gold rounded-full animate-spin" />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className="max-w-[90vw] max-h-[88vh] object-contain select-none"
        draggable={false}
        style={{
          display: loaded ? undefined : 'none',
          userSelect: 'none',
          WebkitUserSelect: 'none',
        }}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
